import { Component, Inject } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { UrlService } from '@service/url/url.service';
import { Contacts, FULL_NAME, NotificationDTO, RestService } from 'cargo-chief-commons';
import { catchError, EMPTY, finalize, tap } from 'rxjs';
import { ErrorActions } from '@state/error';
import { UtilService } from '@service/util/util.service';
import { SNACKBAR } from '@domain/constants/snackbar-setting';

@Component({
	selector: 'app-confirm-contact-dialog',
	templateUrl: 'confirm-contact.component.html',
})
export class ConfirmContactDialogComponent {
	FULL_NAME = FULL_NAME;

	isRequestInProgress = false;
	contact: Contacts;

	constructor(
		public dialogRef: MatDialogRef<ConfirmContactDialogComponent>,
		private readonly urlService: UrlService,
		private readonly restService: RestService,
		private readonly utilService: UtilService,
		@Inject(MAT_DIALOG_DATA) public dialogData: NotificationDTO
	) {
		this.contact = this.dialogData.contact;
	}

	closeDialog(): void {
		this.dialogRef.close();
	}

	useContact() {
		this.isRequestInProgress = true;
		const url = this.urlService.addAccountCarrierContactMapsUrl();
		const contact = this.dialogData.contact;
		const payload = {
			carrierContactMapId: contact.id,
			primaryContact: contact.primaryContact,
			isMailReceiver: contact.isMailReciever,
			fromEmail: contact.fromEmail
		};
		this.restService
			.POST(url, payload)
			.pipe(
				finalize(() => (this.isRequestInProgress = false)),
				catchError(() => EMPTY)
			)
			.subscribe({
				next: (_) => {
					this.closeDialog();
					this.utilService.showSnackbar('Contact confirmed', SNACKBAR.SUCCESS, SNACKBAR.ACTION);
				},
				error: () =>
					ErrorActions.error.show({ payload: { message: 'Unable to confirm. Please try again.' } }),
			});
	}
}
